export default __webpack_public_path__ + "images/cd9e77256db62cd4f2e50702aa850f19-rock.webp";